var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph2",style:(("height:" + _vm.height + "; width:" + _vm.width))},[_c('canvas',{attrs:{"id":_vm.id,"width":500 * 2,"height":400}})])}
var staticRenderFns = []

export { render, staticRenderFns }